import { Link } from "react-router-dom";
import HeroSection from "@/pages/home/components/HeroSection";
import LatestClues from "@/pages/home/components/LatestClues";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import SubmitProcess from "@/pages/home/components/SubmitProcess";
import HotRanking from "@/pages/home/components/HotRanking";
import FaqAccordion from "@/pages/home/components/FaqAccordion";
import Testimonials from "@/pages/home/components/Testimonials";
import HomeCta from "@/pages/home/components/HomeCta";
import ClueCard from "@/components/feature/ClueCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { useSeo } from "@/hooks/useSeo";
import { clues, faqs } from "@/mocks/clueData";

export default function Home() {
  useSeo({
    title: "17.cc网友爆料站 - 网友爆料与投稿吃瓜入口，支持匿名爆料",
    description:
      "17.cc网友爆料站提供网友爆料与投稿吃瓜入口，支持匿名爆料与用户投稿。如果你有17.cc吃瓜投稿或线索征集需求，可在这里了解投稿方式与审核流程，让更多人看到你的真实见闻。",
    keywords: "17.cc,17.cc网友爆料,17.cc投稿吃瓜,17.cc匿名爆料,线索征集",
    path: "/",
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "17.cc 网友爆料站",
        url: "https://17.cc/",
        description: "网友爆料与投稿吃瓜入口，支持匿名爆料与线索征集。",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://17.cc/clues?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "17.cc 网友爆料站",
        url: "https://17.cc/",
        email: "contact@17.cc",
        description: "面向网友的爆料与投稿社区，鼓励在核实与尊重隐私的前提下分享真实见闻。",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ],
  });

  const moreClues = clues.slice(4, 10);

  return (
    <>
      <HeroSection />
      <LatestClues />
      <CategoryGrid />

      <section className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="flex items-end justify-between gap-4">
              <SectionHeading eyebrow="持续更新" icon="ri-newspaper-line" title="更多网友投稿" />
              <Link
                to="/clues"
                className="hidden whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800 sm:block"
              >
                全部投稿
              </Link>
            </div>
            <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
              {moreClues.map((clue) => (
                <ClueCard key={clue.id} clue={clue} variant="compact" />
              ))}
            </div>
          </div>
          <div className="lg:col-span-4">
            <HotRanking />
          </div>
        </div>
      </section>

      <SubmitProcess />
      <FaqAccordion />
      <Testimonials />
      <HomeCta />
    </>
  );
}